module.exports = __webpack_public_path__ + "static/img/pay-loading.4a3b9fc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-loading.gif
// module id = 8g/d
// module chunks = 0